import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=3c9f6db8&scoped=true&"
import script from "@/components/chat/Chat.ts?vue&type=script&lang=ts&"
export * from "@/components/chat/Chat.ts?vue&type=script&lang=ts&"
import style0 from "@/components/chat/chat.scss?vue&type=style&index=0&id=3c9f6db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9f6db8",
  null
  
)

export default component.exports